export const has = (obj, prop) => {
    return Object.prototype.hasOwnProperty.call(obj, prop);
};


export function get(object, path, defaultValue = undefined) {
    if (!path) throw TypeError('path should be a non-empty string');

    const keys = path.split('.');
    let curr = object;

    while (curr && keys.length) {
        const key = keys.shift();
        if (!has(curr, key)) return defaultValue;
        curr = curr[key];
    }

    return curr;
}
